import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useCallback, useEffect } from 'react';

// @mui
import {
  Card,
  Grid,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
// import USERLIST from '../_mock/devices_list';
import ClanOruzje from './ClanOruzje';
import ClanOdlikovanja from './ClanOdlikovanja';
import ClanKazne from './ClanKazne';
import ClanKerovi from './ClanKerovi';
import ClanClanarine from './ClanClanarine';
import ClanFoto from './ClanFoto';
// import PRODUCTS from '../_mock/products';
import { ProductSort, ProductList, ProductCartWidget, ProductFilterSidebar } from '../sections/@dashboard/products';

// console.log(PRODUCTS);

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'IMEI', label: 'IMEI', alignCentar: true },
  { id: 'vlasnik', label: 'Vlasnik', alignRight: false },
  { id: 'ime', label: 'Ime', alignRight: false },
  { id: 'tiptrackera', label: 'Tip trackera', alignRight: false },
  { id: 'aktivan', label: 'Aktivan', alignRight: false },
  { id: 'online', label: 'Online', alignRight: false },
  { id: 'today', label: 'Today', alignRight: false },
  { id: 'blokiran', label: 'Blokiran', alignRight: false },
  { id: 'saldo', label: 'Saldo', alignRight: false },
  { id: 'last', label: 'Last seen', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.vlasnik.toLowerCase() === query.toLowerCase());
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ClanProfil(props) {
  const [open, setOpen] = useState(null);  
  
  const [clan, setClan] = useState([]);
  
  const [id, setId] = useState(props.vlasnik);
  
  const [dataloaded, setDataLoaded] = useState(false);
  
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
  
  
  console.log("clan profil " + props.vlasnik);
  
  
  /*
  const str1 = 'http://89.46.196.228:3000/api/hunters/';
  const str2 = str1.concat('', props.vlasnik);
  const url = str2;
  console.log(url);
  
  const refreshdata = async () => {
  const data = await (
        await fetch(
		url
        )
		).json();
		setId(props.vlasnik);
	    setClan(data[0]);
		setDataLoaded(true);
    };
  */
	
  function refreshData() {
	  
  console.log(props.vlasnik);  
  const str1 = SERVER_URL + "/subscribers/";
  const str2 = str1.concat('', props.vlasnik);
  const url = str2;
  console.log(url);
		
    fetch(url)
      .then((res) => res.json())
      .then((json) => {
		setId(props.vlasnik);
        setClan(json);
		setDataLoaded(true);
        console.log(json);
      });
	}
	
  if (id !== props.vlasnik)
	refreshData();
	
  useEffect(() => { 

  });	
  
  const prod = 
  {
  "id": "1",
  "cover": "/assets/images/products/product_1.jpg",
  "ime": "Adis Smajovic",
  "lovackodrustvo": "Biserna Gorazde",
  "adresa": "Gorazde",
  "telefon": "+38761044183",
  "datumpolaganja": "1.2.2006."
}

  return (
    <>

	  
		{(id !== '') ? 
		  	<ClanKerovi vlasnik={id} />
		: id}

    </>
  );
}
